import React, { useState } from "react";
import faqImg from "../assets/question.avif";

const faqData = [
  {
    question: "What services do you provide?",
    answer:
      "We provide ITR filing, GST compliance, TDS/TCS services, bookkeeping, tax planning, and business advisory solutions.",
  },
  {
    question: "Do you work with small businesses and startups?",
    answer:
      "Yes, we specialize in startups, freelancers, and SMEs with affordable compliance solutions.",
  },
  {
    question: "How do you ensure accuracy and compliance?",
    answer:
      "We follow updated tax laws and perform multi-level checks for complete accuracy.",
  },
  {
    question: "Can you help during tax season?",
    answer:
      "Yes, we handle filing, notices, and tax planning to ensure a stress-free experience.",
  },
];

const FAQSection = () => {
  const [activeIndex, setActiveIndex] = useState(0);

  const toggle = (index) => {
    setActiveIndex(index === activeIndex ? null : index);
  };

  return (
    <>
      <style>{`
        .faq-section {
          background: #EFFFE1;
          padding: 60px 20px;
        }

        .faq-container {
          max-width: 1100px;
          margin: auto;
        }

        .faq-title {
          text-align: center;
          font-size: 36px;
          font-weight: 700;
          margin-bottom: 60px;
          color: #1e2d23;
        }

        .faq-content {
          display: flex;
          gap: 50px;

          /* ✅ KEY FIX */
          align-items: flex-start; /* prevents image movement */
        }

        /* IMAGE FIXED */
        .faq-image {
          flex: 0 0 420px; /* fixed width */
        }

        .faq-image img {
          width: 100%;
          height: 500px; /* fixed height */
          object-fit: cover;
          border-radius: 10px;
        }

        /* FAQ LIST */
        .faq-list {
          flex: 1;
          display: flex;
          flex-direction: column;
          gap: 20px;
        }

        .faq-item {
          background: #DCF6C6;
          border-radius: 16px;
          padding: 20px;
          cursor: pointer;
        }

        .faq-question {
          display: flex;
          align-items: center;
          gap: 15px;
          font-weight: 600;
        }

        .icon {
          width: 35px;
          height: 35px;
          border-radius: 50%;
          background: #97E074;
          display: flex;
          align-items: center;
          justify-content: center;
          font-size: 18px;
          font-weight: bold;
        }

        .faq-answer {
          margin-top: 15px;
          font-size: 14px;
          color: #444;
          line-height: 1.6;
        }

        /* RESPONSIVE */
        @media (max-width: 900px) {
          .faq-content {
            flex-direction: column;
          }

          .faq-image {
            flex: none;
          }

          .faq-image img {
            height: auto;
          }
        }
      `}</style>

      <section className="faq-section">
        <div className="faq-container">

          <h2 className="faq-title">
            Find answers to common accounting questions.
          </h2>

          <div className="faq-content">

            {/* IMAGE */}
            <div className="faq-image">
              <img src={faqImg} alt="FAQ" />
            </div>

            {/* FAQ */}
            <div className="faq-list">
              {faqData.map((item, index) => (
                <div
                  key={index}
                  className="faq-item"
                  onClick={() => toggle(index)}
                >
                  <div className="faq-question">
                    <div className="icon">
                      {activeIndex === index ? "−" : "+"}
                    </div>
                    {item.question}
                  </div>

                  {activeIndex === index && (
                    <div className="faq-answer">
                      {item.answer}
                    </div>
                  )}
                </div>
              ))}
            </div>

          </div>
        </div>
      </section>
    </>
  );
};

export default FAQSection;